// Handle contact form data passed in url //
$(function () {
    // get the url query string
    const queryString = window.location.search;

    //convert query string to parameters
    const urlParams = new URLSearchParams(queryString);

    /* Auto fill message from URL */
    if (urlParams.has('message')) {
        const autoFormMessage = urlParams.get('message');
        document.getElementById("00N1500000H2mMK").value = autoFormMessage;
    }
    /* Auto fill subject from URL */
    if (urlParams.has('subject')) {
        const autoFormSubject = urlParams.get('subject');
        document.getElementById("subject").value = autoFormSubject;
    }
});

// checks if form is valid
function validateForm(e){
    e.preventDefault();

    // Get form element for validation
    const formElement = document.getElementById("contact-form");

    // check if form is valid
    if(formRequiredValid(formElement)){

        // hide the form
        document.getElementById("message-form").classList.add('hide');
        // display the loading message
        document.getElementById("formUserMessageCopy").innerHTML = "<h1>Your request is processing...</h1>Waiting on a response from the server";
        document.getElementById("formUserMessage").classList.add('show');

        /* execute the reCAPTCHA system - will call captchaServerCheck when done  */
        grecaptcha.execute();
    }else{
        //highlight what is not valid in form
    }
}

// contact form submission
function captchaServerCheck(){

    //Get the form
    const formElement = document.getElementById("contact-form");

    // Form inputs into key/value pairs
    let formData = new FormData(formElement);

    //get all np-input-text elements
    let allNpText = document.getElementsByTagName("np-input-text");

    // loop through np inputs and add to formData
    for (var i=0; i < allNpText.length; i++){
        if(allNpText[i].hasAttribute('name')){
            formData.append(allNpText[i].name, allNpText[i].value);
        }
    }

    // adding select value to formData
    formData.append('subject', document.getElementById("subject").value);

    // adding textarea value to formData
    formData.append('message', document.getElementById("00N1500000H2mMK").value);


    // covert form key/value pairs to urlSearchParams
    const data = new URLSearchParams(formData);

    const formApiEndpoint = window.location.origin+'/newadminapi/contact/submission';
    //const formApiEndpoint = 'https://dev4.optitrack.private/newadminapi/contact/submission'; //for testing

    // send form for processing
    fetch(formApiEndpoint, {method: 'post', body: data})
    .then(response => { //convert response to json
        return response.json();
    })
    .then(data => {
        if(data == true){
            const userMessage = document.getElementById("formUserMessage");
            userMessage.innerHTML = "<h1>Thanks for contacting us.</h1>You will hear from us soon.<br><img class='success' src='//deva90sapmc8w.cloudfront.net/primeX41-perspective-319.png' alt='Prime 41'>";

        }else{
            const userMessage = document.getElementById("formUserMessage");
            userMessage.innerHTML = "<h1>Error!</h1>The server did not accept your request."
        }
    });
}

//returns if form is valid (does not have any inputs with the 'error' class)
function formRequiredValid(formElement) {
    //get all required inputs
    const requiredInputs = formElement.querySelectorAll("*[required]");

    //loop through required inputs
    for(var i =0; i < requiredInputs.length; i++){
        //if required input does not have the 'validated' attribute fail the form validation
        if(requiredInputs[i].getAttribute('validated') ==='false'){

            //set the 'touched' attribute which will validate the input
            requiredInputs[i].setAttribute('touched','true');

            // form in not valid
            return false;
        }
    }
    // form is valid
    return true;
}
